import { toast } from 'react-toastify';
import { loginWithPhantom } from '../../utils/WalletProviders/phantom';
import { loginWithXverse } from '../../utils/WalletProviders/xVerse';
import { loginWithGenerated } from '../../utils/WalletProviders/generated';
import { deleteCookie, setCookie } from '../../utils/cookies';



// setCookie("userToken", response.token, 1);
export const login = (dispatch) => async (walletTypeOrData) => {
    const toastId = toast.loading("Logging in...");
    try {
        dispatch({ type: "SET_LOADING", payload: true });
        let data;

        // Handle different wallet types
        if (typeof walletTypeOrData === 'string') {
            // Traditional wallet providers
            switch (walletTypeOrData) {
                case "PHANTOM":
                    data = await loginWithPhantom();
                    break;
                case "XVERSE":
                    data = await loginWithXverse();
                    break;
                default:
                    throw new Error("Unsupported wallet type");
            }
        } else if (typeof walletTypeOrData === 'object' && walletTypeOrData.walletType === 'GENERATED') {
            // Generated wallet login (data already processed)
            data = walletTypeOrData;
        } else {
            throw new Error("Invalid wallet data");
        }

        if (!data.token) {
            throw new Error("No auth token received");
        }
        setCookie("userToken", data.token, 3);

        delete data.token;
        localStorage.setItem("user", JSON.stringify(data));
        dispatch({ type: "LOGIN", payload: data });
        toast.update(toastId, {
            render: "Login successful!",
            type: "success",
            isLoading: false,
            autoClose: 3000,
        });
        dispatch({ type: "SET_LOADING", payload: false });
    } catch (error) {
        dispatch({ type: "SET_ERROR", payload: error.message });
        toast.update(toastId, {
            render: `Error logging in: ${ error.message }`,
            type: "error",
            isLoading: false,
            autoClose: 3000,
        });
        dispatch({ type: "SET_LOADING", payload: false });
    }
};
export const logout = (dispatch) => async () => {
    const toastId = toast.loading("Logging out...");
    try {
        dispatch({ type: "SET_LOADING", payload: true });
        deleteCookie("userToken");
        localStorage.removeItem("user");
        dispatch({ type: "LOGOUT" });
        toast.update(toastId, {
            render: "Logout successful!",
            type: "success",
            isLoading: false,
            autoClose: 3000,
        });
        dispatch({ type: "SET_LOADING", payload: false });
    } catch (error) {
        dispatch({ type: "SET_ERROR", payload: error.message });
        toast.update(toastId, {
            render: `Error logging out: ${ error.message }`,
            type: "error",
            isLoading: false,
            autoClose: 3000,
        });
        dispatch({ type: "SET_LOADING", payload: false });
    }
};